<div *ngIf="!isShowResult">
  <h2 mat-dialog-title mat-dialog-draggable-title>{{'title.add_new_department' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickBtnCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <form #f="ngForm" (ngSubmit)=" f.form.valid && onCreateGroup()" [appCheckCode]="['code']"
    appFocusFirstElement style="margin-top: 10px;">
    <mat-dialog-content>

          <div class="row">

            <!-- Mã phòng ban -->
            <div class="col-sm-6">
              <mat-form-field class="mat-full-width">
                <input (focusout)="userGroup.code = userGroup.code.trim()" #focusInput autocomplete="off" id="code"
                  matInput [placeholder]="'search_form.department_code' | translate" type="text" name="code"
                  [(ngModel)]="userGroup.code" #code="ngModel" [ngClass]="{ 'is-invalid': f.submitted || code.invalid }"
                  required maxlength="200" />
                <button mat-button *ngIf="userGroup.code" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="userGroup.code=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || code.invalid">
                  <span class="text-error" *ngIf="code?.errors?.required">
                    {{'validation.department_code_requied' | translate}}
                  </span>
                  <span class="text-error" *ngIf="code?.errors?.validIp">
                    {{'validation.code_format' | translate}}
                  </span>
                </mat-error>
                <mat-error *ngIf="code?.errors?.duplicate">
                  {{ 'validation.err_department_code_duplicate' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Phân loại -->
            <div class="col-sm-6">
              <div>
                <mat-form-field>
                  <mat-label>{{'search_form.department_type' | translate}}</mat-label>
                  <mat-select #departmentTypeSelect (focusout)="(checkFocus = true)"
                              (focus)="commonService.openComboBox(checkFocus, departmentTypeSelect)" id="departmentType"
                              [(ngModel)]="userGroup.departmentType"
                              (selectionChange)="checkFocus = false;"
                              #departmentType="ngModel"
                              required
                              name="departmentType">
                    <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.departmentTypeSelect)">
                      {{ 'form.department' | translate }}
                    </mat-option>
                    <mat-option [value]="2" (click)="this.commonService.closeDropdownList(this.departmentTypeSelect)">
                      {{ 'form.branch' | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || departmentType.invalid">
              <span class="text-error" *ngIf="departmentType?.errors?.required">
                {{'validation.department_type_required' | translate}}
              </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Tên phòng ban -->
            <div class="col-sm-12">
                <mat-form-field class="mat-full-width">
                  <input (focusout)="userGroup.name = userGroup.name.trim()" #focusInput autocomplete="off" id="name"
                    matInput [placeholder]="'search_form.department_name' | translate" type="text" name="name"
                    [(ngModel)]="userGroup.name" #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted || name.invalid }"
                    required maxlength="200" />
                  <button mat-button *ngIf="userGroup.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="userGroup.name=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || name.invalid">
                    <span class="text-error" *ngIf="name?.errors?.required">
                      {{'validation.department_name_requied' | translate}}
                    </span>
                  </mat-error>
                  <mat-error *ngIf="name?.errors?.duplicate">
                    {{ 'validation.err_department_name_duplicate' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- Mô tả -->
              <div class="col-sm-12">
                <mat-form-field class="mat-full-width">
                  <textarea (focusout)="userGroup.description = userGroup.description.trim()" type="text" matInput
                    [placeholder]="'search_form.department_description' | translate" rows="2" name="description" id="description"
                    [(ngModel)]="userGroup.description" maxlength="500"></textarea>
                </mat-form-field>
              </div>

              <!-- Người dùng thuộc phòng ban -->
              <div class="col-sm-12" style="padding-right: 2rem !important;margin-bottom: 15px;">
                <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
                  <span class="ant-upload pb-2" style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'search_form.department_user' | translate}}</span>
                </mat-panel-title>
                <div>
                  <nz-input-group [nzSuffix]="suffixUserInput">
                    <input nz-input [(ngModel)]="inputUserValue"
                           (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                           [ngModelOptions]="{ standalone: true }"
                           placeholder="{{'search_form.department_search_placeholder' | translate}}" id="inputUser" maxlength="200"/>
                    <nz-autocomplete #autoUserSearching>
                      <nz-auto-option *ngFor="let user of filteredUserOptions"
                                      (selectionChange)="autocompleteUserSelected($event, user)"
                                      [nzValue]="''">{{user.fullName}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></nz-auto-option>
                    </nz-autocomplete>
                  </nz-input-group>
                  <ng-template #suffixUserInput>
                    <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                  </ng-template>
                  <ng-template #indicatorUserInput>
                    <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px;"></i>
                  </ng-template>
                </div>

                <!-- Bảng thêm mới người dùng thuộc phòng ban -->
                <!-- <div class="mat-table-container">
                  <mat-table [dataSource]="listUserInDepartment" [ngClass]="{'is-data': listUserInDepartment.length > 0}">
                    người dùng
                    <ng-container matColumnDef="user">
                      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                        {{'department_manage.dialog_view.user' | translate}}</mat-header-cell>
                      <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                      {{username.email}}
                      </mat-cell>
                  </ng-container>

                  Switch người đại diện
                  <ng-container matColumnDef="representative">
                    <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                      {{'search_form.department_representative' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                      <nz-switch [(ngModel)]="username.isRepresentative" (click)="setRepresentative(username)" [ngModelOptions]="{standalone: true}"></nz-switch>
                    </mat-cell>
                </ng-container>

                 Xóa
                <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{'department_manage.dialog_view.action' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                    (nzOnConfirm)="deleteUser(username)" [nzIcon]="iconDel"
                    nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                   <i class="fa fa-trash" aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                 </a>
                 <ng-template #iconDel>
                   <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                 </ng-template>
                  </mat-cell>
              </ng-container>
                  </mat-table>
                </div> -->
                <nz-table nzBordered [nzNoResult]="null" [nzData]="listUserInDepartment" nzShowPagination=false
                          class="mt-2 ant-table-no-border border-top-0" [ngClass]="{'is-data': listUserInDepartment.length > 0}">
                          <tbody *ngIf="listFilterUserInDepartment.length > 0" class="editable-row">
                            <tr>
                              <td class="text-center text-primary" style="font-weight: 600 !important; font-size: 14px">
                                {{'department_manage.dialog_view.user' | translate}}</td>
                              <td class="text-center text-primary" style="font-weight: 600 !important; font-size: 14px; width: 25%;">
                                {{'search_form.department_representative' | translate}}</td>
                              <td class="text-center text-primary" style="font-weight: 600 !important; font-size: 14px;">
                                {{'department_manage.dialog_view.action' | translate}}</td>
                            </tr>
                  <tr *ngFor="let username of listUserInDepartment" class="editable-row">
                    <td>{{username.email}} <span *ngIf="username.userPosition">- {{username.userPosition}}</span></td>
                    <td class="text-center">
                      <nz-switch [(ngModel)]="username.isRepresentative" (click)="setRepresentative(username)" [ngModelOptions]="{standalone: true}"></nz-switch>
                    </td>
                    <td class="text-center">
                      <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                         (nzOnConfirm)="deleteUser(username)" [nzIcon]="iconDel"
                         nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                        <i class="fa fa-trash" aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                      </a>
                      <ng-template #iconDel>
                        <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>
                </nz-table>
              </div>

              <!-- Người đại diện -->
              <!-- <div class="col-sm-12">
                <mat-form-field class="w-100">
                  <mat-label>
                    {{'search_form.department_representative' | translate}}
                  </mat-label>
                  <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                  [(ngModel)]="userGroup.representativeIdString" >
                  <input (keydown)="$event.stopPropagation()" type="text" [(ngModel)]="searchRepresentativeInput"
                    matInput placeholder="{{'alert.search_department_representative_placeholder' | translate}}" maxlength="200"
                    style="padding-left: 15px;height: 48px;color: #000000;" (input)="onInputChange($event)" name="searchInput" id="searchInput"/>
                  <mat-divider></mat-divider>
                    <mat-option >
                      {{'search_form.department_representative_choose' | translate}}</mat-option>
                      <mat-option  (click)="this.commonService.closeDropdownList(this.statusSelect)" [ngStyle]="{'display': item.isDeleted == false ? null : 'none'}"
                      [value]="item.id" *ngFor="let item of listFilterUserInDepartment">{{item.email}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->

          </div>

    </mat-dialog-content>

    <mat-divider></mat-divider>

    <!-- Huỷ bỏ & Lưu -->
    <mat-dialog-actions align="center">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-raised-button [disabled]="(!isFormChanging && !change) || !userGroup.name || !userGroup.code || code.invalid" type="submit" cdkFocusInitial color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        {{'button.add_department' | translate}}
      </button>
    </mat-dialog-actions>
  </form>
</div>



  <div *ngIf="isShowResult">
    <!-- header -->
    <h2 mat-dialog-title mat-dialog-draggable-title> {{'department_manage.dialog_add_user.title' | translate}}
      <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <!-- end header -->
    <mat-divider></mat-divider>
    <mat-dialog-content>
      <div class="row pt-3 pb-3">
        <div class="col-12">
            <p>{{'department_manage.dialog_add_user.success' | translate}} <span style="font-weight: bold;">{{countSuccess}}</span></p>
            <p>{{'department_manage.dialog_add_user.failed' | translate}} <span style="font-weight: bold;">{{countError}}</span></p>
        </div>

          <div class="col-12" *ngIf="listErrorUser.length > 0">
            <div class="mat-table-container">
                <mat-table [dataSource]="listErrorUser" class="mat-table-col-extra-sm">
                    <!-- Full name -->
                    <ng-container matColumnDef="fullName">
                        <mat-header-cell *matHeaderCellDef style="width: 50%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                            {{'headertable.name' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 50%;">
                            <span matTooltip="{{element.fullName}}" class="fix-width" style="margin-left: -5px;">
              {{element.fullName}}
            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Lỗi -->
                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef style="max-width: 50%;" class="mat-header-cell-center">
                            {{'headertable.error' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{'alert.add_user_department_error_notify' | translate}}" class="" style="max-width: 50%;">
                            <span class="fix-width">{{'alert.add_user_department_error_notify' | translate}}</span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumnsResult; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsResult;" matRipple class="element-row" [cdkDetailRow]="row">
                    </mat-row>
                </mat-table>
            </div>
        </div>

      </div>
    </mat-dialog-content>
    <div>
      <mat-divider></mat-divider>
      <mat-dialog-actions class="mt-2" align="center">
        <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="closeDialog()" type="button" style="margin-bottom: 0px !important;">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.close' | translate}}
        </button>
        </mat-dialog-actions>
    </div>
</div>
